import React, { useEffect, useState } from 'react';
import { VinCentrixLogo } from '../Logo/VinCentrixLogo';

const LoadingScreen = () => {
  const [forceHidden, setForceHidden] = useState(false);

  // Safety valve for authenticated dashboard loads. The dashboard can already be
  // mounted underneath this fixed overlay while an older loading-state branch gets
  // stuck. Never let the overlay block an authenticated dashboard indefinitely.
  useEffect(() => {
    let timer;
    try {
      const isDashboard = window.location.pathname === '/dashboard';
      const token = localStorage.getItem('token') || localStorage.getItem('vincentrix_token');
      const dealer = localStorage.getItem('dealer') || localStorage.getItem('dealership') || localStorage.getItem('vincentrix_dealer');

      if (isDashboard && token && dealer) {
        timer = window.setTimeout(() => setForceHidden(true), 2500);
      }
    } catch (error) {
      console.warn('Loading screen session check failed:', error);
    }

    return () => {
      if (timer) window.clearTimeout(timer);
    };
  }, []);

  if (forceHidden) return null;

  return (
    <div className="vc-loading-screen">
      <div className="vc-loading-glow" />

      <div className="vc-loading-logo">
        <VinCentrixLogo size={120} showText={true} />
      </div>

      <div className="vc-loading-bar">
        <div className="vc-loading-shimmer" />
      </div>

      <p className="vc-loading-text">Loading...</p>

      <style>{`
        .vc-loading-screen {
          position: fixed;
          inset: 0;
          width: 100%;
          height: 100vh;
          height: 100dvh;
          min-height: 100dvh;
          box-sizing: border-box;
          overflow: hidden;
          padding: max(24px, env(safe-area-inset-top)) max(20px, env(safe-area-inset-right)) max(24px, env(safe-area-inset-bottom)) max(20px, env(safe-area-inset-left));
          background: #000;
          background-image:
            radial-gradient(ellipse 80% 50% at 50% -20%, rgba(59,130,246,.15), transparent),
            radial-gradient(ellipse 60% 40% at 100% 100%, rgba(59,130,246,.1), transparent),
            radial-gradient(ellipse 40% 60% at 0% 100%, rgba(99,102,241,.08), transparent);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          animation: fadeIn .3s ease-out;
        }
        .vc-loading-glow {
          position: absolute;
          width: min(500px, 90vw);
          height: min(500px, 90vw);
          border-radius: 50%;
          background: radial-gradient(circle, rgba(59,130,246,.25) 0%, transparent 70%);
          filter: blur(clamp(36px, 12vw, 80px));
          animation: glowPulse 3s ease-in-out infinite;
          pointer-events: none;
        }
        .vc-loading-logo {
          position: relative;
          z-index: 1;
          animation: float 3s ease-in-out infinite;
          max-width: calc(100vw - 48px);
          transform-origin: center;
        }
        .vc-loading-bar {
          margin-top: 48px;
          width: min(200px, 58vw);
          height: 2px;
          background: rgba(255,255,255,.1);
          border-radius: 1px;
          overflow: hidden;
          position: relative;
          flex: 0 0 auto;
        }
        .vc-loading-shimmer {
          position: absolute;
          inset-block: 0;
          left: 0;
          width: 40%;
          background: linear-gradient(90deg, transparent, rgba(59,130,246,.8), transparent);
          box-shadow: 0 0 20px rgba(59,130,246,.6);
          animation: shimmer 1.5s ease-in-out infinite;
        }
        .vc-loading-text {
          margin: 24px 0 0;
          font-size: 13px;
          font-weight: 500;
          color: rgba(255,255,255,.5);
          letter-spacing: 3px;
          text-transform: uppercase;
          animation: fadeIn .5s ease-out .3s both;
          font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif;
          text-shadow: 0 0 20px rgba(59,130,246,.3);
          flex: 0 0 auto;
        }
        @media (max-width: 600px) {
          .vc-loading-screen { padding-inline: 24px; }
          .vc-loading-logo {
            transform: scale(.72);
            max-width: none;
          }
          .vc-loading-bar { margin-top: 28px; }
          .vc-loading-text { margin-top: 20px; font-size: 11px; letter-spacing: 2.4px; }
        }
        @media (max-width: 380px), (max-height: 650px) {
          .vc-loading-logo { transform: scale(.62); }
          .vc-loading-bar { margin-top: 18px; }
          .vc-loading-text { margin-top: 16px; }
        }
        @keyframes glowPulse {
          0%,100% { opacity:.3; transform:scale(1); }
          50% { opacity:.6; transform:scale(1.2); }
        }
        @keyframes float {
          0%,100% { translate:0 0; }
          50% { translate:0 -10px; }
        }
        @keyframes shimmer {
          0% { left:-40%; }
          100% { left:100%; }
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
